import React from "react";
import { Star } from "lucide-react";

export default function StarRating({ value = 0, onChange, size = 18, testid = "star-rating" }) {
  const interactive = typeof onChange === "function";
  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      {[1, 2, 3].map((i) => {
        const active = i <= value;
        const star = (
          <Star
            size={size}
            strokeWidth={1.5}
            className={active ? "text-primary" : "text-zinc-700"}
            fill={active ? "#D4AF37" : "none"}
          />
        );
        if (!interactive) {
          return (
            <span key={i} data-testid={`${testid}-${i}`} aria-label={`rating ${i}`}>
              {star}
            </span>
          );
        }
        return (
          <button
            key={i}
            type="button"
            data-testid={`${testid}-${i}`}
            onClick={(e) => { e.stopPropagation(); e.preventDefault(); onChange(i === value ? 0 : i); }}
            className="cursor-pointer transition-transform hover:scale-110"
            aria-label={`rating ${i}`}
          >
            {star}
          </button>
        );
      })}
    </div>
  );
}
